module.exports = __webpack_public_path__ + "img/user6.a86d6cf0.png";